import { showCartNotice } from "./cart-notice";

export const setupQuantityControls = () => {
  const updateButtonState = (container) => {
    const input = container?.querySelector("input[type='number']");
    const decrementButton = container?.querySelector(".quantity-decrement");
    const incrementButton = container?.querySelector(".quantity-increment");

    if (!input) return;

    const currentValue = parseInt(input.value, 10);
    const minValue = parseInt(input.min, 10) || 0;
    const maxValue = parseInt(input.max, 10) || Infinity;

    decrementButton?.classList.toggle("disabled", currentValue <= minValue);
    incrementButton?.classList.toggle("disabled", currentValue >= maxValue);
  };

  const handleButtonClick = (event) => {
    const decrementButton = event.target.closest(".quantity-decrement");
    const incrementButton = event.target.closest(".quantity-increment");
    const container = (decrementButton || incrementButton)?.closest(
      ".quantity"
    );
    const input = container?.querySelector("input[type='number']");

    if (input) {
      const previousValue = input.value;

      decrementButton && input.stepDown();
      incrementButton && input.stepUp();

      if (input.value === previousValue) {
        if (incrementButton) showCartNotice(input.dataset.maxNotice);

        return;
      }

      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));

      updateButtonState(container);
    }
  };

  const handleInputChange = (event) => {
    const input = event.target.closest("input[type='number']");
    const container = input?.closest(".quantity");
    if (container) updateButtonState(container);
  };

  /**
   * A typed quantity is only held to `max` once the customer is done typing — clamping on every
   * keystroke would rewrite the field under their fingers.
   */
  const handleTypedValue = (event) => {
    const input = event.target.closest("input[type='number']");
    const container = input?.closest(".quantity");
    const maxValue = parseInt(input?.max, 10);

    if (!container || Number.isNaN(maxValue)) return;

    if (parseInt(input.value, 10) > maxValue) {
      input.value = maxValue;

      updateButtonState(container);
      showCartNotice(input.dataset.maxNotice);
    }
  };

  const handleCartUpdate = () => {
    document.querySelectorAll(".quantity").forEach(updateButtonState);
  };

  document.addEventListener(
    "click",
    (event) => {
      if (event.target.closest(".yith-wapo-addon-type-product .option-add-to-cart")) {
        event.stopPropagation();
      }
      handleButtonClick(event);
    },
    true
  );
  document.addEventListener("input", handleInputChange);
  // Before the cart's own `change` handler, which is registered later, so it sees the clamped
  // value and not the one that was typed.
  document.addEventListener("change", handleTypedValue);

  jQuery(document.body).on("updated_cart_totals updated_wc_div", handleCartUpdate);

  document.querySelectorAll(".quantity").forEach(updateButtonState);
};

const syncQuantityState = (option) => {
  const checkbox = option.querySelector(".yith-proteo-standard-checkbox");
  const quantity = option.querySelector(".option-add-to-cart .quantity");
  if (!checkbox || !quantity) return;

  const enabled = checkbox.checked;
  quantity.classList.toggle("disabled", !enabled);
  quantity
    .querySelectorAll("input, button")
    .forEach((el) => (el.disabled = !enabled));
};

export const syncAddonQuantityToggle = () => {
  document.querySelectorAll(".yith-wapo-option").forEach(syncQuantityState);
};

export const setupAddonQuantityToggle = () => {
  document.addEventListener("change", (event) => {
    if (event.target.matches(".yith-proteo-standard-checkbox")) {
      const option = event.target.closest(".yith-wapo-option");
      if (option) syncQuantityState(option);
    }
  });

  jQuery(document).on("yith-wapo-after-reload-addons", syncAddonQuantityToggle);

  syncAddonQuantityToggle();
};
